import Pagination from "../../layout/Pagination.vue"
import Loading from "vue-loading-overlay";
import $ from 'jquery';

export default {
    name: "BuyDeviceList",
    components: {
        Loading,
        Pagination
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            allDataList: [],
            product_view_type_grid: 'active',
            product_view_type_list: '',
            product_view_class: 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device',
            product_view_inner_image_class: 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0',
            product_view_inner_block_class: 'col-lg-12 col-sm-12 col-md-12 col-xs-12',
            product_view_list_row_class: '',
            product_view_price_cart_class: '',
            product_view_image_margin_top: 'margin-top:20px; height:120px;',
            product_view_gird_hide: false,
            product_filter: {},
            setProductBuyFilterURL: 'api/purchase/filter/buy-product',
            setProductBuySortingURL: 'api/purchase/filter/sorting',
            imagePath: this.$api + "assets/buy/device/info/",
            setAddToCartPurchaseUrl: this.$api + 'api/purchase/add-to-cart',
            purchaseProductCart:{items:[],total_quantity:0,total_price:0},
        }
    },
    created() {
        document.title = "Buy A Device";
        this.getDeviceCategory({
            "url": "api/purchase/product/json"
        });
        var productBrand = [];
        var productModel = [];
        var productCondition = [];
        var productCarrier = [];
        var productStroage = [];
        $("body").on("click", ".filter_search", function() {
            var filterValue = $(this).val();
            var checkType = $(this).attr('data-id');
            if($(this).prop("checked")) {
                //var checkType = $(this).attr('data-id');
                
                if(checkType == "Brand"){
                    productBrand.push(filterValue);
                }
                else if(checkType == "Model"){
                    productModel.push(filterValue);
                }
                else if(checkType=="Condition"){
                    productCondition.push(filterValue);
                }
                else if(checkType == "Stroage"){
                    productStroage.push(filterValue);
                }
                else if(checkType == "Carrier"){
                    productCarrier.push(filterValue);
                }
            }
            else {
                //var checkType = $(this).attr('data-id');
                //var filterValue = $(this).val();
                if(checkType == "Brand") {
                    productBrand.splice(productBrand.indexOf(filterValue), 1);
                }
                else if(checkType == "Model") {
                    productModel.splice(productModel.indexOf(filterValue), 1);
                }
                else if(checkType == "Condition") {
                    productCondition.splice(productCondition.indexOf(filterValue), 1);
                }
                else if(checkType == "Stroage") {
                    productStroage.splice(productStroage.indexOf(filterValue), 1);
                }
                else if(checkType == "Carrier") {
                    productCarrier.splice(productCarrier.indexOf(filterValue), 1);
                }     
            }
            this.product_filter = {
                "brand": productBrand,
                "brand_model": productModel,
                "condition": productCondition,
                "stroage": productStroage,
                "carrier": productCarrier
            };
            this.productBrandFilter();
        });

        $("body").on("change", ".rangeSorting", function() {
            var rangeSorting = $(this).val();
            if(rangeSorting.length > 0) {
                this.productFilterSorting(rangeSorting);
            }
        });
    },
    methods: {
        productBrandFilter: function() {
            this.isLoading = true;
            this.$axios.post(this.$api + this.setProductBuyFilterURL, this.product_filter)
            .then(response => {
                let data = response.data;
                console.log('Filter Response: ', data);
                this.allDataList.data = data.data;
                this.isLoading = false;
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });
            console.log('Product brand filter: ', this.product_filter);
        },
        productFilterSorting: function(sortID) {
            console.log('sortID: ', sortID);
            this.isLoading = true;
            this.$axios.post(this.$api + this.setProductBuySortingURL, {'sortDataType': sortID})
            .then(response => {
                let data = response.data;
                console.log('Sorting Response: ', data);
                this.allDataList.data = data.data;
                this.isLoading = false;
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        cartAdd(product_id, quantity, image){

            if(localStorage.getItem('purchase_cart'))
            {
                console.log('Before Parse ',localStorage.getItem('purchase_cart'));
                if(localStorage.getItem('purchase_cart')==null)
                {
                    this.purchaseProductCart.total_price=0;
                    this.purchaseProductCart.total_quantity=0;
                    this.purchaseProductCart.items=[];

                    let purchaseProductCartString=JSON.stringify(this.purchaseProductCart);
                    console.log('Type of object = ',typeof(purchaseProductCartString));

                    localStorage.setItem('purchase_cart',this.purchaseProductCartString);
                }
                else
                {
                    if(localStorage.getItem('purchase_cart').length>0)
                    {
                        let oldCart=JSON.parse(localStorage.getItem('purchase_cart'));
                        console.log('oldCart = ',oldCart);
                        if(oldCart!=null)
                        {
                            if(oldCart.items!== undefined)
                            {
                                this.purchaseProductCart=oldCart;
                                console.log("Local Stroage Not Empty");
                                console.log(oldCart.items);
                            }
                            else
                            {
                                console.log("Local Stroage Empty");
                            }
                        }
                        else
                        {
                            this.purchaseProductCart.total_price=0;
                            this.purchaseProductCart.total_quantity=0;
                            this.purchaseProductCart.items=[];

                            let purchaseDeviceCartString=JSON.stringify(this.purchaseProductCart);
                            console.log('Type of object = ',typeof(purchaseDeviceCartString));

                            localStorage.setItem('purchase_cart',purchaseDeviceCartString);
                        }
                        
                    }
                    else
                    {
                        console.log("Local Stroage Empty");
                    }
                }
                
                
            }
            else
            {
                this.purchaseProductCart.total_price=0;
                this.purchaseProductCart.total_quantity=0;
                this.purchaseProductCart.items=[];

                let purchaseProductCartString=JSON.stringify(this.purchaseProductCart);
                console.log('Type of object = ',typeof(purchaseProductCartString));

                localStorage.setItem('purchase_cart',purchaseProductCartString);
            }

            // this.$store.state.pageLoader = true;
            // console.log(this.myPurchaseCart);
            // this.$emit('updatePurchaseCartBox', "+"+quantity); 

            let formData = new FormData();
                formData.append('pro_id', product_id);
                formData.append('pro_quantity', quantity);
            console.log(formData);    
            // axios.post(this.setAddToCartPurchaseUrl, formData)
            // .then(response => {
            //     console.log(response.data);
            //     let res=response.data;
            //     this.$emit('updatePurchaseCartBox', res.totalQty);  
            //     this.loadStatus = true;
            //     this.$store.state.pageLoader = false;

            //     this.$router.push({name:'buyCartBox'});
            // })
            // .catch(e => {
            //     console.log(e);
            // });

            if(this.purchaseProductCart.length>0)
            {
                const checkCartItem = this.purchaseProductCart.items.filter(item => item.cart_id===product_id); 
                if(checkCartItem.length > 0){
                    console.log('Item is already available');
                }
            }
            else
            {
                this.purchaseProductCart={items:[],total_quantity:0,total_price:0};
            }
            console.log(this.purchaseProductCart);

            this.$axios.post(this.setAddToCartPurchaseUrl, formData)
            .then(response => {
                console.log(response.data);
                let data = response.data;
                let cartOld={};
                let checkStatus=[];
                let checkStatusIndex=null;
                console.log('Axios Local= ',localStorage.getItem('purchase_cart'));
                if(localStorage.getItem('purchase_cart').length>0)
                {
                    console.log('Session checking = ');
                    cartOld=JSON.parse(localStorage.getItem('purchase_cart'));
                    let oldCartItem=cartOld.items;
                    if(oldCartItem.length > 0)
                    {
                        checkStatus=oldCartItem.filter(item => item.cart_id==product_id);
                        console.log('Session Filter = ',checkStatus.length);
                        oldCartItem.forEach((t,index)=>{
                            console.log('Looping = ',t, index);
                            if(t.cart_id==product_id)
                            {
                                checkStatusIndex=index;
                            }
                        });
                    }
                }

                console.log('Item Index Found = ',checkStatusIndex);

                console.log('checkStatus = ',checkStatus);
                if(checkStatus.length > 0){
                    
                    console.log('Item found on filter');
                    cartOld.total_price+=(data.device_price*quantity);
                    cartOld.total_quantity+=quantity;
                    cartOld.items[checkStatusIndex].qty+=quantity;
                    cartOld.items[checkStatusIndex].price+=(data.device_price*quantity);
                }
                else
                {
                    console.log('Item not found on filter');
                        console.log('cartOld = ', cartOld);

                        if(cartOld.items==0)
                        {
                            cartOld.items=[];
                        }

                        cartOld.items.push({
                            'cart_id':data.pro_id,
                            'name':data.product.device_name,
                            'unit_price':data.device_price,
                            'price':(data.device_price*quantity),
                            'qty':quantity,
                            'deviceImage':image,
                            'item':data.product
                        });
                        cartOld.total_price+=(data.device_price*quantity);
                        cartOld.total_quantity+=quantity;

                        this.$emit('updatePurchaseCartBox', cartOld.total_quantity);  
                }

                let purchaseProductCartString=JSON.stringify(cartOld);
                console.log('Type of object = ',typeof(purchaseProductCartString));

                localStorage.setItem('purchase_cart',purchaseProductCartString);
                console.log('this.sellDeviceCart Updated=',purchaseProductCartString);
                console.log('this.sellDeviceCart stroiage=',localStorage.getItem('purchase_cart'));

                //let res=response.data;
                
                //this.loadStatus = true;
                //this.$store.state.pageLoader = false;

                this.$router.push({name:'Cart'});
            })
            .catch(e => {
                console.log(e);
            });
    
        },
        getDeviceCategory: function(obj) {
            this.isLoading = true;
            this.$axios.get(this.$api + obj.url)
            .then(response => {
                this.allDataList = response.data;
                this.isLoading = false;
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });    
        },
        setProductTypeView: function(viewName) {
            if(viewName == "grid") {
                this.product_view_type_grid = 'active';
                this.product_view_type_list = '';
                this.product_view_class = 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12';
                this.product_view_list_row_class = '';
                this.product_view_price_cart_class = '';
                this.product_view_image_margin_top = 'margin-top: 20px; height: 120px;';
                this.product_view_gird_hide = false;
            }
            else if(viewName == "list") {
                this.product_view_type_grid = '';
                this.product_view_type_list = 'active';
                this.product_view_class = 'col-xs-12 col-md-12 col-lg-12 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-3 col-sm-12 col-md-3 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-6 col-sm-12 col-md-9 col-xs-12 pt-4';
                this.product_view_list_row_class = 'row pt-4';
                this.product_view_price_cart_class = 'display:none !important;';
                this.product_view_image_margin_top = 'margin-top:0px; height:120px; margin-bottom: 10px;';
                this.product_view_gird_hide = true;
            }
            else {
                this.product_view_type_grid = 'active';
                this.product_view_type_list = '';
                this.product_view_class = 'col-xs-12 col-md-3 col-lg-3 mb-4 cat-block-device';
                this.product_view_inner_image_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12 p-0';
                this.product_view_inner_block_class = 'col-lg-12 col-sm-12 col-md-12 col-xs-12';
                this.product_view_list_row_class = '';
                this.product_view_price_cart_class = '';
                this.product_view_image_margin_top = 'margin-top: 20px; height: 120px;';
                this.product_view_gird_hide = false;
            }
        },
        productDetails: function(identifier) {
            this.$router.push({
                name: 'BuyDeviceProductDetails', 
                params: { 
                    identifier: identifier 
                }
            });
        }
    }
}